import React from 'react';
import { IconCheck } from '@tabler/icons-react';
import { Button } from '@planne-software/uni/Button';

import TimeShiftSection from './TimeShiftSection';

import { PopoverInner, TriggerValue, UnavailableMessage } from './styles';
import { useTimeSelector } from './useTimeSelector';
import { SequentialSlotShell } from '../SequentialSlotShell';
import { SelectPopover } from '@planne-software/uni';

const TimeSelector = () => {
  const state = useTimeSelector();

  const { popover, content } = state;

  return (
    <SequentialSlotShell slot='time'>
      <SelectPopover
        disablePopover={popover.disabled}
        name='product-booking-schedule-time'
        className='product-booking-schedule-time'
        placeholder={popover.placeholder}
        fullWidth
        size='sm'
        disabled={popover.disabled}
        open={popover.open}
        onOpenChange={popover.onOpenChange}
        selectedElement={
          popover.selectedFormattedTime ? <TriggerValue>{popover.selectedFormattedTime}</TriggerValue> : undefined
        }
        footer={
          <Button fullWidth variant='contained' startSlot={<IconCheck size={20} />} onClick={popover.onConfirm}>
            {popover.confirmLabel}
          </Button>
        }
        isBottomSheet
        bottomSheetTitle={popover.bottomSheetTitle}
      >
        <PopoverInner>
          {content.showUnavailableMessage ? (
            <UnavailableMessage>{content.unavailableMessage}</UnavailableMessage>
          ) : (
            <>
              <TimeShiftSection
                hours={content.morningHours}
                title={content.daySectionTitle}
                hasOnlyOneShift={content.hasOnlyOneShift}
                selectedMinutes={content.selectedMinutes}
                onSelectHour={content.onSelectHour}
              />
              <TimeShiftSection
                hours={content.lateHours}
                title={content.nightSectionTitle}
                hasOnlyOneShift={content.hasOnlyOneShift}
                selectedMinutes={content.selectedMinutes}
                onSelectHour={content.onSelectHour}
              />
            </>
          )}
        </PopoverInner>
      </SelectPopover>
    </SequentialSlotShell>
  );
};

export default TimeSelector;
export { useTimeSelector } from './useTimeSelector';
